import * as _ from 'lodash';
import * as PIXI from 'pixi.js';

import AreaObjectEnemy from '@/assets/js/game/AreaObjectEnemy';
import AreaObjectItem from '@/assets/js/game/AreaObjectItem';
import GameManager from '@/assets/js/game/GameManager';

import ObjectData from '@/assets/data/object';
import ObjectMapData from '@/assets/data/objectMap';

export default class MapArea {
  constructor(levelData, areaNumber) {
    const areaNumberData = _.filter(levelData, { area_number: areaNumber });
    const areaData = _.sample(areaNumberData);

    this.width = GameManager.calcRatio(GameManager.gameWidth * 2);
    this.height = GameManager.calcRatio(GameManager.gameHeight);
    this.areaNumber = areaNumber;
    this.areaId = areaData.area_id;

    this.objectList = [];
    this.container = new PIXI.Container();
    this.container.x = (areaNumber - 1) * this.width;

    this._setObject();
  }

  update(delta, moveX) {
    const viewPositionX = -moveX - this.container.x;
    const isActive =
      viewPositionX >= -GameManager.calcRatio(GameManager.gameWidth) &&
      viewPositionX <= this.width;
    if (!isActive) return;
    for (let i = 0; i < this.objectList.length; i++) {
      const areaObject = this.objectList[i];
      areaObject.update(delta, viewPositionX);
    }
  }

  onResize() {
    for (let i = 0; i < this.objectList.length; i++) {
      const areaObject = this.objectList[i];
      areaObject.onResize();
    }
  }

  _setObject() {
    const objectList = _.filter(ObjectMapData, { area_id: this.areaId });
    for (let i = 0; i < objectList.length; i++) {
      let objectItem = null;
      const objectInfo = objectList[i];
      const objectId = objectInfo.object_id;
      const x = objectInfo.center_x;
      const y = objectInfo.center_y;
      const objectData = _.find(ObjectData, { id: objectId });

      if (objectData.type === 'item') {
        objectItem = new AreaObjectItem(objectData, x, y);
      }

      if (objectData.type === 'enemy') {
        objectItem = new AreaObjectEnemy(objectData, x, y);
      }

      this.container.addChild(objectItem.container);
      this.objectList.push(objectItem);
    }
  }

  _setAreaLine() {
    const line = new PIXI.Graphics();
    line.x = 0;
    line.y = 0;
    line
      .beginFill(0x000000)
      .drawRect(0, 0, 2, this.height)
      .endFill();
    this.container.addChild(line);
  }
}
